/* Penoblo Mega-Menue.
   Inhalte koennen optional ueber sections/pnb-mega-menu.liquid als JSON im Customizer ueberschrieben werden. */
(function(){
/* Gesamte Initialisierung als aufrufbare Funktion: laeuft beim Laden und bei
   Theme-Editor-Re-Renders (shopify:section:load) erneut. Idempotent: alle
   DOM-Referenzen werden pro Aufruf frisch geholt, buildNav/buildMega rendern
   per innerHTML neu, der Drawer-Enhancer prueft auf vorhandene Injektion. */
/* ================================================================
   MENÜ-WÖRTERBUCH für die veröffentlichten Sprachen (EN/FR)
   ----------------------------------------------------------------
   Die Menü-Labels kommen als JSON-Metaobjekt aus dem Penoblo Studio
   und lassen sich von Shopify nicht übersetzen. Das Wörterbuch steht
   bewusst HIER und nicht in einem Liquid-Snippet: So hängt die
   Übersetzung an derselben Datei wie das Menü selbst — sie kann nicht
   dadurch ausfallen, dass eine zusätzliche Datei nicht synchronisiert
   oder in einem anderen Sprachkontext gerendert wird.

   Marken-, Modell- und Serienbezeichnungen (Montblanc, Meisterstück,
   Safari …) stehen bewusst nicht drin und bleiben überall gleich.
   Fehlt ein Label, erscheint es unverändert auf Deutsch — nie leer.
   ================================================================ */
/* PNB_MENU_I18N kommt aus assets/pnb-menu-i18n.js — nur auf EN/FR geladen
   (sections/pnb-mega-menu.liquid). Fehlt die Datei (DE), bleibt das Menue
   unuebersetzt-deutsch; der typeof-Check in MENU_I18N faengt das ab. */
var PNB_MENU_I18N = window.PNB_MENU_I18N || {};

function pnbInitMegaMenu(){
  try { window.pnbAutoscaleLogo = pnbAutoscaleLogo; } catch (e) {} // hoisted export (Harness/Robustheit)

  if (!document.getElementById("penNav")) return;

  /* ===== Internationalisierung: Locale-Praefix (z.B. /fr, /en) ===== */
  /* routes.root_url wird per data-root vom Liquid geliefert ('/' = Standardsprache) */
  var ROOT = (document.getElementById("penNav").getAttribute("data-root") || "/").replace(/\/$/, "");
  var BACK_LABEL = document.getElementById("penNav").getAttribute("data-back-label") || "zurück";
  /* Filterwerte je Sprache (14.09.2026): Die Produktart im Link
     (filter.p.product_type=Füller) ist ein sprachabhaengiger Wert — auf /en
     heisst sie "Fountain pen", auf /fr "Stylo-plume". Das Menue traegt die
     deutschen Werte; ohne Uebersetzung zeigt die Zielseite "0 Produkte"
     (Befund Browsercheck 14.09.2026, Marken > Montblanc > Fueller auf /en).
     Die Zuordnung kommt aus der Sprachdatei (pnb.menu.product_type_values),
     Form "Füller=Fountain pen|Kugelschreiber=Ballpoint pen"; mehrere
     Zielwerte mit ";" ergeben mehrere Parameter (Shopify verodert sie), so
     lassen sich uneinheitliche Uebersetzungen wie "Stylo-plume"/"Stylo plume"
     zusammenfassen. Markenfilter (filter.p.vendor) sind sprachneutral. */
  var TYPE_VALUES = (function(){
    var map = {};
    var raw = document.getElementById("penNav").getAttribute("data-type-values") || "";
    raw.split("|").forEach(function(pair){
      var i = pair.indexOf("=");
      if (i <= 0) return;
      var von = pair.slice(0, i).trim();
      var nach = pair.slice(i + 1).split(";").map(function(s){ return s.trim(); }).filter(Boolean);
      if (von && nach.length) map[von] = nach;
    });
    return map;
  })();
  function locFilter(href){
    if (href.indexOf("filter.p.product_type=") < 0) return href;
    return href.replace(/([?&])filter\.p\.product_type=([^&#]*)/g, function(m, sep, enc){
      var val;
      try { val = decodeURIComponent(enc.replace(/\+/g, " ")); } catch (e) { return m; }
      var ziel = TYPE_VALUES[val];
      if (!ziel) return m;
      return ziel.map(function(v, i){ return (i === 0 ? sep : "&") + "filter.p.product_type=" + encodeURIComponent(v); }).join("");
    });
  }
  function loc(href){
    if (!href || typeof href !== "string") return href;
    if (!ROOT) return href;                         // Standardsprache -> unveraendert
    if (href.charAt(0) !== "/") return href;        // extern / Anker -> unveraendert
    href = locFilter(href);                         // Filterwerte in die Sprache der Seite
    if (href === ROOT || href.indexOf(ROOT + "/") === 0) return href; // schon lokalisiert
    return ROOT + href;
  }

/* ================================================================
   PENOBLO MEGA-MENÜ — Datenmodell
   ----------------------------------------------------------------
   Jede Top-Navigation hat:
     - label, href, optional `sale:true`
     - levels: { <key>: <Level-Definition> }   (key "root" = Startansicht)
   Ein Level besteht aus bis zu 3 Spalten (cols). Spaltentypen:
     - cards   : Bild-Kachel-Grid (mit optionalem `to` = Drill-down-Key)
     - links   : Linkliste (cols2 = zweispaltig), optional all-Block nach <hr>
     - promo   : Werbebild + Button
     - brandhead (in linker Spalte eines Drill-downs): Logo + Zurück-Link
   Bilder = echte Penoblo-CDN-Assets.
   ================================================================ */
  /* Asset-Basis des AKTUELLEN Themes (per data-Attribut aus Liquid); Alt-Theme-URL nur als Notfall-Fallback */
  const NAV_DATA = document.getElementById("penNav");
  const CDN = (NAV_DATA && NAV_DATA.getAttribute("data-asset-base")) || "//www.penoblo.de/cdn/shop/t/243/assets/";
  const img = (f) => !f ? "" : (/^(https?:)?\/\//.test(f) ? f : CDN + f);
  /* Standard-Preisstaffel (rechte Spalte der Drill-downs und Wurzel-Spalten).
     Steht hier oben, weil treeToMenu (Studio-Menue) sie ebenfalls braucht. */
  const PRICE_HEADING = (NAV_DATA && NAV_DATA.getAttribute("data-price-heading")) || "Nach Preis shoppen";
  const PRICE = (function () {
    var a = NAV_DATA && NAV_DATA.getAttribute("data-price-list");
    return a ? a.split("|") : ["unter 25 €","ab 25 € – 100 €","ab 100 € – 300 €","ab 300 € – 500 €","ab 500 € – 1000 €","ab 1000 €"];
  })();

  /* ===== Penoblo URL-Aufloesung ===== */
  const BRAND_MAP = {"Aurora": "aurora-88", "Bossert & Erhard": "bossert-und-erhard-fueller", "Caran d'Ache": "caran-dache-schreibgeraete", "Cerruti 1881": "cerruti-exklusiv", "Cleo Skribent": "cleo-skribent", "Cross": "cross-fueller", "Diplomat": "diplomat-schreibgeraete", "Faber-Castell": "faber-castell", "Graf von Faber-Castell": "graf-von-faber-castell", "Graf v. Faber-Castell": "graf-von-faber-castell", "HUGO BOSS": "hugo-boss-schreibgerate", "Hugo Boss": "hugo-boss-schreibgerate", "Kaweco": "kaweco-schreibgerate", "LAMY": "lamy", "Lamy": "lamy", "Maybach": "maybach", "Montblanc": "montblanc-schreibgerate", "Otto Hutt": "otto-hutt-schreibgeraete", "Parker": "parker", "Pelikan": "pelikan", "Porsche Design": "porsche-design-fueller", "Sheaffer": "sheaffer-100", "Waldmann": "waldmann", "Waterman": "waterman-schreibgerate", "BENU": "benu-fueller", "Esterbrook": "esterbrook-schreibgerate", "Platinum": "platinum-pens", "Sailor": "sailor-pen", "TWSBI": "twsbi-fueller", "Tibaldi": "tibaldi-fueller", "S.T. Dupont": "st-dupont", "Pilot": "pilot-fueller", "Montegrappa": "montegrappa", "Robert Oster": "robert-oster-tintenglaser", "Rössler": "roessler-papiere", "Swarovski": "swarovski-schreibgeraete", "Tomoe River": "tomoe-river", "Tony Perotti": "tony-perotti", "Nuuna": "nuuna-notizbucher", "Legami": "legami", "Festina": "festina-fueller", "Pininfarina": "pininfarina-ethergraf", "e+m Holzprodukte": "em-holzprodukte", "Octopus Tinte": "octopus-tinten", "Diamine": "diamine-tinten", "Pilot Iroshizuku": "pilot-iroshizuku"};
  const CAT_MAP = {"Füller": "fueller", "Kugelschreiber": "kugelschreiber", "Tintenroller": "rollerball", "Bleistift": "bleistift", "Stifte-Sets": "bundle-produkte", "Bestseller": "bestsellers", "Neuheiten": "neuheiten", "Limiteds": "limitierte-schreibgeraete", "Alle Refills": "refills", "Tintenfässer": "tintenfasser-1", "Tintenpatronen": "tintenpatronen", "Tintenproben": "tintenproben", "Kugelschreiberminen": "kugelschreiber-refills", "Rollerballminen": "rollerball-minen", "Bleistiftminen": "bleistift-minen", "Konverter für Füller": "konverter-fur-fuller", "Füller Reinigungsset": "refills", "Sets & Bundles": "bundle-produkte", "Writers Club": "montblanc-writers-edition", "Schulfüller": "fueller", "Sale": "sale", "Geschenke": "besondere-geschenke", "Gutscheine": "besondere-geschenke", "Alle Gravuren": "schreibgeraete-mit-gravur", "Alle Kugelschreiber": "kugelschreiber", "Alle Füller": "fueller", "Alle Tintenroller": "rollerball", "Alle Bleistifte": "bleistift"};
  const slugify = (s) => s.toLowerCase().replace(/&/g,'und').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  const PRODUCT_TYPE_FILTERS = {
    "Füller": "Füller",
    "Alle Füller": "Füller",
    "Kugelschreiber": "Kugelschreiber",
    "Alle Kugelschreiber": "Kugelschreiber",
    "Tintenroller": "Tintenroller",
    "Alle Tintenroller": "Tintenroller",
    "Bleistift": "Bleistift",
    "Bleistifte": "Bleistift",
    "Alle Bleistifte": "Bleistift",
    "Refills": "Refills",
    "Accessoires": "Accessoires"
  };
  const appendFilter = (base, key, value) =>
    base + (base.includes("?") ? "&" : "?") + key + "=" + encodeURIComponent(value);
  const isProductType = (name) => !!PRODUCT_TYPE_FILTERS[name];
  const isKnownBrand = (name) => !!BRAND_MAP[name];
  const urlBrand = (name) => BRAND_MAP[name] ? "/collections/"+BRAND_MAP[name]
       : "/collections/all?filter.p.vendor=" + encodeURIComponent(name.replace(/ v\. /,' von '));
  const urlCat = (name) => CAT_MAP[name] ? "/collections/"+CAT_MAP[name]
       : "/search?q=" + encodeURIComponent(name) + "&type=product";
  const urlBrandType = (brand, type) => appendFilter(urlBrand(brand), "filter.p.product_type", PRODUCT_TYPE_FILTERS[type]);
  const urlTypeBrand = (type, brand) => appendFilter(urlCat(type), "filter.p.vendor", brand.replace(/ v\. /,' von '));
  const PRICE_RANGE = {
    "unter 25 €":"filter.v.price.lte=25",
    "ab 25 € – 100 €":"filter.v.price.gte=25&filter.v.price.lte=100",
    "ab 100 € – 300 €":"filter.v.price.gte=100&filter.v.price.lte=300",
    "ab 300 € – 500 €":"filter.v.price.gte=300&filter.v.price.lte=500",
    "ab 500 € – 1000 €":"filter.v.price.gte=500&filter.v.price.lte=1000",
    "ab 1000 €":"filter.v.price.gte=1000"
  };
  const urlPrice = (label, base) => (base||"/collections/edle-schreibgerate") + "?" + (PRICE_RANGE[label]||"");


  const DEFAULT_MENU = [
    /* ---------------------------------------------------------- SCHREIBGERÄTE */
    {
      label: "Schreibgeräte", href: "/collections/edle-schreibgerate",
      levels: {
        root: {
          left: {
            heading: "Wähle einen Schreibgerätetyp",
            cards: [
              { label: "", img: "menu-allpens-format-3.jpg", href: "/collections/edle-schreibgerate" },
              { label: "Kugelschreiber", img: "menu-kugelschreiber-format.jpg", to: "kugelschreiber" },
              { label: "Füller", img: "menu-fueller-format-1.jpg", to: "fuller" },
              { label: "Tintenroller", img: "menu-tintenroller-format.jpg", to: "tintenroller" },
              { label: "Bleistift", img: "menu-bleistifte-format.jpg", to: "bleistift" },
              { label: "Stifte-Sets", img: "menu-stiftesets-format.jpg", href: "/collections/sets-und-geschenksets" },
              { label: "Bestseller", img: "bestseller-2023-menue.jpg", href: "/collections/bestsellers" },
              { label: "Neuheiten", img: "neuheiten-desktop-menue.jpg", href: "/collections/neuheiten" },
              { label: "Limiteds", img: "limiteds-2023-menue.jpg", href: "/collections/limitierte-schreibgeraete" }
            ]
          },
          mid: {
            heading: "Highlights",
            links: ["Füller Reinigungsset","Tintenproben","Sets & Bundles","Writers Club","Bestseller","Neuheiten","Schulfüller","Sale","Limited Editions","Geschenke","Gutscheine"]
          },
          right: {
            heading: "Nach Preis shoppen",
            pricelist: ["unter 25 €","ab 25 € – 100 €","ab 100 € – 300 €","ab 300 € – 500 €","ab 500 € – 1000 €","ab 1000 €"],
            all: "Alle Schreibgeräte"
          }
        },
        kugelschreiber: brandDrill("Kugelschreiber", null, {
          types: [
            { label: "Alle Kugelschreiber", img: "menu-alle-kugelschreiber-format.jpg" },
            { label: "Hugo Boss", img: "hugo-boss-kugelschreiber-menue-desktop.jpg" },
            { label: "Caran d'Ache", img: "carandache-kugelschreiber-format.jpg" },
            { label: "Maybach", img: "maybach-kugelschreiber-menue-desktop.jpg" },
            { label: "Graf v. Faber-Castell", img: "gvfc-kugelschreiber-format.jpg" },
            { label: "Lamy", img: "lamy-kugelschreiber-format.jpg" }
          ],
          brandsHeading: "Kugelschreiber nach Marke",
          brands: ["Aurora","Bossert & Erhard","Caran d'Ache","Cerruti 1881","Cleo Skribent","Cross","Diplomat","Faber-Castell","Graf von Faber-Castell","HUGO BOSS","Kaweco","LAMY","Maybach","Montblanc","Otto Hutt","Parker","Pelikan","Porsche Design","Sheaffer","Waldmann","Waterman"],
          all: "Alle Kugelschreiber"
        }),
        fuller: brandDrill("Füller", null, {
          types: [
            { label: "Alle Füller", img: "menu-alle-fueller.jpg" },
            { label: "Graf v. Faber-Castell", img: "gvfc-fueller-marke-format.jpg" },
            { label: "Waldmann", img: "waldmann-fueller-format.jpg" },
            { label: "BENU", img: "benu-fueller-menue-desktop.jpg" },
            { label: "Kaweco", img: "kaweco-fueller-format.jpg" },
            { label: "Lamy", img: "lamy-fuller-format.jpg" }
          ],
          brandsHeading: "Füller nach Marke",
          brands: ["Aurora","BENU","Bossert & Erhard","Caran d'Ache","Cleo Skribent","Cross","Diplomat","Esterbrook","Faber-Castell","Graf von Faber-Castell","Kaweco","LAMY","Maybach","Montblanc","Otto Hutt","Parker","Pelikan","Platinum","Sailor","Sheaffer","TWSBI","Waldmann","Waterman"],
          all: "Alle Füller"
        }),
        tintenroller: brandDrill("Tintenroller", null, {
          types: [
            { label: "Alle Tintenroller", img: "menu-alle-tintenroller.jpg" },
            { label: "Graf v. Faber-Castell", img: "graf-von-faber-castell-tintenroller-menue-desktop.jpg" },
            { label: "Waldmann", img: "waldmann-tintenroller-format.jpg" },
            { label: "Faber-Castell", img: "faber-castell-tintenroller-menue-desktop.jpg" },
            { label: "Maybach", img: "maybach-tintenroller-menue-desktop.jpg" },
            { label: "Lamy", img: "lamy-tintenroller-format.jpg" }
          ],
          brandsHeading: "Tintenroller nach Marke",
          brands: ["Aurora","BENU","Bossert & Erhard","Caran d'Ache","Cerruti 1881","Cleo Skribent","Cross","Diplomat","Faber-Castell","Graf von Faber-Castell","Kaweco","LAMY","Maybach","Montblanc","Otto Hutt","Pelikan","Sheaffer","Waldmann"],
          all: "Alle Tintenroller"
        }),
        bleistift: brandDrill("Bleistift", null, {
          types: [
            { label: "Alle Bleistifte", img: "menu-alle-bleistifte.jpg" },
            { label: "Graf v. Faber-Castell", img: "gvfc-bleistift-format.jpg" },
            { label: "Caran d'Ache", img: "carandache-bleistift-format.jpg" },
            { label: "Waldmann", img: "waldmann-bleistift-format.jpg" },
            { label: "Otto Hutt", img: "ottohutt-bleistift-format.jpg" },
            { label: "Kaweco", img: "kaweco-bleistift-format.jpg" }
          ],
          brandsHeading: "Bleistifte nach Marke",
          brands: ["Aurora","Caran d'Ache","Cleo Skribent","Cross","Diplomat","Graf von Faber-Castell","Kaweco","Otto Hutt","Pelikan","Waldmann","e+m Holzprodukte"],
          all: "Alle Bleistifte"
        })
      }
    },

    /* ---------------------------------------------------------- MARKEN */
    {
      label: "Marken", href: "/pages/marken-bei-penoblo",
      levels: {
        root: {
          left: {
            heading: "Top Marken",
            cards: [
              { label: "Montblanc", img: "menu-montblanc-2020.jpg", href: "/collections/montblanc-schreibgerate", wide:true },
              { label: "Graf von Faber-Castell", img: "menu-graf-2020.jpg", href: "/collections/graf-von-faber-castell", wide:true },
              { label: "Maybach", img: "maybach-menu-desktop.jpg", href: "/collections/maybach", wide:true },
              { label: "Waldmann", img: "menu-waldmann-2020.jpg", href: "/collections/waldmann", wide:true },
              { label: "Bossert & Erhard", img: "bossert-erhard-menu-desktop.jpg", href: "/collections/bossert-und-erhard-fueller", wide:true },
              { label: "Hugo Boss", img: "hugo-boss-logo-menue.png", href: "/collections/hugo-boss-schreibgerate", wide:true },
              { label: "Kaweco", img: "menu-kaweco-2020.jpg", href: "/collections/kaweco-schreibgerate", wide:true },
              { label: "Faber-Castell", img: "menu-fc-2020.jpg", href: "/collections/faber-castell", wide:true },
              { label: "Diplomat", img: "menu-diplomat-2020.jpg", href: "/collections/diplomat-schreibgeraete", wide:true },
              { label: "BENU", img: "benu-fueller-menue-desktop.jpg", href: "/collections/benu-fueller", wide:true },
              { label: "Otto Hutt", img: "menu-ottohutt-2021.jpg", href: "/collections/otto-hutt-schreibgeraete", wide:true },
              { label: "Caran d'Ache", img: "menu-carandache-2020.jpg", href: "/collections/caran-dache-schreibgeraete", wide:true },
              { label: "S.T. Dupont", img: "menu-st-dupont-leder.jpg", href: "/collections/st-dupont", wide:true },
              { label: "Sailor", img: "sailor-menue.jpg", href: "/collections/sailor-pen", wide:true },
              { label: "Pilot", img: "pilot-logo-menue.jpg", href: "/collections/pilot-fueller", wide:true },
              { label: "Montegrappa", img: "menu-montegrappa-2020.jpg", href: "/collections/montegrappa", wide:true },
              { label: "Waterman", img: "waterman-menue.jpg", href: "/collections/waterman-schreibgerate", wide:true },
              { label: "LAMY", img: "menu-lamy-2020.jpg", href: "/collections/lamy", wide:true },
              { label: "Parker", img: "menu-parker-2022.jpg", href: "/collections/parker", wide:true },
              { label: "Platinum", img: "platinum-logo-menue.png", href: "/collections/platinum-pens", wide:true },
              { label: "Porsche Design", img: "menu-porsche-design.jpg", href: "/collections/porsche-design-fueller", wide:true },
              { label: "Sheaffer", img: "menu-sheaffer.jpg", href: "/collections/sheaffer-100", wide:true }
            ],
            wideCards: true
          },
          mid: {
            heading: "Alle Marken",
            cols2: true,
            links: ["Aurora","BENU","Bossert & Erhard","Caran d'Ache","Cerruti 1881","Cleo Skribent","Cross","Diamine","Diplomat","El Casco","Esterbrook","Faber-Castell","Festina","Graf von Faber-Castell","Hugo Boss","Kaweco","LAMY","Leuchtturm","Maybach","Montblanc","Montegrappa","Nuuna","Otto Hutt","Parker","Pelikan","Pilot","Platinum","Porsche Design","Robert Oster","Rössler","Sailor","Sheaffer","Swarovski","Tibaldi","Tomoe River","Tony Perotti","TWSBI","Waldmann","Waterman","YStudio","e+m Holzprodukte","Legami Milano"],
            all: "Alle Marken"
          },
          right: {
            promoHeading: "Die Schreibrevolution",
            promo: { img: "ebook-desktop-menue-feature-205.jpg", btn: null, tall:true }
          }
        },
        gvfc: brandDrill("Graf von Faber-Castell", "menu-graf-2020.jpg", {
          types: [
            { label: "Füller", img: "menu-gvfc-fueller-new.jpg" },
            { label: "Kugelschreiber", img: "menu-gvfc-kugelschreiber.jpg" },
            { label: "Tintenroller", img: "menu-gvfc-tintenroller.jpg" },
            { label: "Bleistifte", img: "menu-gvfc-bleistift.jpg" }
          ],
          brandsHeading: "GvFC Kollektionen",
          brands: ["Classic","Guilloche","Tamitio","Bentley","Anello","Pen of the Year"],
          all: "Alles von Graf von Faber-Castell"
        }),
        maybach: brandDrill("Maybach", "maybach-menu-desktop.jpg", {
          types: [
            { label: "Füller", img: "maybach-fueller-menue-desktop.jpg" },
            { label: "Kugelschreiber", img: "maybach-kugelschreiber-menue-desktop.jpg" },
            { label: "Tintenroller", img: "maybach-tintenroller-menue-desktop.jpg" },
            { label: "Refills", img: "maybach-refills-menue-desktop.jpg" },
            { label: "Accessoires", img: "maybach-accessoires-menue-desktop.jpg" }
          ],
          brandsHeading: "Maybach Kollektionen",
          brands: ["The Peak I","The Peak II","The Genius II","The Realm I","The Key Moment I","The Key Point I","The Fortune I","The Treasurer III","The Charming I"],
          all: "Alles von Maybach"
        }),
        carandache: brandDrill("Caran d'Ache", "menu-carandache-2020.jpg", {
          types: [
            { label: "Kugelschreiber", img: "menu-carandache-ks.jpg" },
            { label: "Füller", img: "menu-carandache-fuller.jpg" },
            { label: "Tintenroller", img: "menu-carandache-tintenroller.jpg" },
            { label: "Bleistifte", img: "menu-carandache-bleistift.jpg" },
            { label: "Refills", img: "menu-carandache-tinte.jpg" }
          ],
          brandsHeading: "Caran d'Ache Kollektionen",
          brands: ["Ecridor","849","Léman","Varius"],
          all: "Alles von Caran d'Ache"
        }),
        lamy: brandDrill("LAMY", "menu-lamy-2020.jpg", {
          types: [
            { label: "Kugelschreiber", img: "menu-lamy-ks.jpg" },
            { label: "Füller", img: "menu-lamy-fueller.jpg" },
            { label: "Tintenroller", img: "menu-lamy-tintenroller.jpg" },
            { label: "Schulfüller", img: "menu-lamy-schulfueller.jpg" },
            { label: "Refills", img: "menu-lamy-tinte.jpg" }
          ],
          brandsHeading: "Lamy Kollektionen",
          cols2: true,
          brands: ["2000","ABC","Accent","AL-Star","Aion","CP 1","Dialog","Imporium","Logo","Lx","Nexx","Pico","Safari","Scala","Studio","Vista"],
          all: "Alles von Lamy"
        }),
        montblanc: brandDrill("Montblanc", "menu-montblanc-2020.jpg", {
          types: [
            { label: "Kugelschreiber", img: "menu-montblanc-kugelschreiber-mb.jpg" },
            { label: "Füller", img: "menu-montblanc-fueller-mb.jpg" },
            { label: "Tintenroller", img: "menu-montblanc-tintenroller-mb.jpg" },
            { label: "Mit Gravur", img: "menu-montblanc-mit-gravur.jpg" },
            { label: "Refills", img: "menu-montblanc-tinte-mb.jpg" }
          ],
          brandsHeading: "Montblanc Kollektionen",
          brands: ["Meisterstück","Starwalker","Writers Edition","Schreibaccessoires"],
          all: "Alles von Montblanc"
        })
      }
    },

    /* ---------------------------------------------------------- TINTEN & MINEN (wie Screenshot) */
    {
      label: "Tinten & Minen", href: "/collections/refills",
      levels: {
        root: {
          left: {
            heading: "Tinte & Minen",
            cards: [
              { label: "", img: "menu-alle-refills.jpg", href: "/collections/refills" },
              { label: "Tintenfässer", img: "menu-tintenfasser-format.jpg", href:"/collections/tintenfasser-1" },
              { label: "Tintenpatronen", img: "menu-tintenpatronen-format.jpg", href:"/collections/tintenpatronen" },
              { label: "Tintenproben", img: "tintenproben-menue-desktop.jpg", href:"/collections/tintenproben" },
              { label: "Kugelschreiberminen", img: "menu-kugelschreibermine-format.jpg", href:"/collections/kugelschreiber-refills" },
              { label: "Rollerballminen", img: "menu-tintenrollermine-format.jpg", href:"/collections/rollerball-minen" },
              { label: "Bleistiftminen", img: "menu-bleistiftminen-format.jpg", href:"/collections/bleistift-minen" },
              { label: "Füller Konverter", img: "menu-konverter-format.jpg", href:"/collections/konverter-fur-fuller" }
            ]
          },
          mid: {
            heading: "Tinte & Minen nach Marke",
            cols2: true,
            links: ["Caran D'Ache","Diamine","Diplomat","Graf von Faber-Castell","Hugo Boss","Kaweco","Maybach","Montblanc","Montegrappa","Otto Hutt","Pelikan","Pilot Iroshizuku","Platinum"],
            all: "Alle Refills"
          },
          right: {
            promoHeading: "",
            promo: { img: "tintenproben-menue-desktop.jpg", btn: "Jetzt entdecken", caption:"Tintenproben" }
          }
        }
      }
    },

    /* ---------------------------------------------------------- GRAVUREN */
    {
      label: "Gravuren", href: "/collections/schreibgeraete-mit-gravur",
      levels: {
        root: {
          left: {
            heading: "Gravuren",
            cards: [
              { label: "Mit Gravur", img: "menu-montblanc-mit-gravur.jpg", href:"/collections/schreibgeraete-mit-gravur" },
              { label: "Geschenkidee", img: "menu-stiftesets-format.jpg", href:"/collections/besondere-geschenke" },
              { label: "Beratung", img: "menu-allpens-format-3.jpg", href:"/pages/kontakt" }
            ]
          },
          mid: {
            heading: "So funktioniert's",
            links: ["Schriftarten ansehen","Beispiele & Inspiration","Häufige Fragen","Lieferzeit Gravur"],
            all: "Mehr über Gravuren"
          },
          right: {
            promoHeading: "Persönlich machen",
            promo: { img: "menu-graf-2020.jpg", btn: "Jetzt gravieren" }
          }
        }
      }
    },

    /* ---------------------------------------------------------- BÜRO & ACCESSOIRES */
    {
      label: "Büro & Accessoires", href: "/collections/burobedarf",
      levels: {
        root: {
          left: {
            heading: "Büro & Accessoires",
            cards: [
              { label: "Etuis", img: "menu-lamy-etui.jpg", href:"/collections/stifteetuis" },
              { label: "Schreibtisch", img: "menu-carandache-etui.jpg", href:"/collections/burobedarf" },
              { label: "Notizbücher", img: "nuuna-menue.jpg", href:"/collections/notizbucher" },
              { label: "Leder", img: "menu-st-dupont-leder.jpg", href:"/collections/leder-accessoires" },
              { label: "Papier", img: "menu-tintenfasser-format.jpg", href:"/collections/briefpapier-blocke" },
              { label: "Accessoires", img: "menu-st-dupont-accessoires.jpg", href:"/collections/burobedarf" }
            ]
          },
          mid: {
            heading: "Nach Marke",
            cols2: true,
            links: ["El Casco","Graf von Faber-Castell","Leuchtturm","Nuuna","Rössler","Tomoe River","Tony Perotti","Legami Milano"],
            all: "Alle Accessoires"
          },
          right: {
            promoHeading: "Geschenke für Schreiber",
            promo: { img: "menu-ottohutt-2021.jpg", btn: "Entdecken" }
          }
        }
      }
    },

    /* ---------------------------------------------------------- GESCHENKE */
    {
      label: "Geschenke", href: "/collections/besondere-geschenke",
      levels: {
        root: {
          left: {
            heading: "Geschenke",
            cards: [
              { label: "Geschenksets", img: "menu-stiftesets-format.jpg", href:"/collections/sets-und-geschenksets" },
              { label: "Gutscheine", img: "menu-allpens-format-3.jpg", href:"/products/geschenkgutschein-im-wert-von-100" },
              { label: "Limiteds", img: "limiteds-2023-menue.jpg", href:"/collections/limitierte-schreibgeraete" },
              { label: "Bestseller", img: "bestseller-2023-menue.jpg", href:"/collections/bestsellers" }
            ]
          },
          mid: {
            heading: "Geschenke nach Anlass",
            links: ["Zum Abschluss","Zum Geburtstag","Für den Chef","Für Studenten","Zur Hochzeit"],
            all: "Alle Geschenkideen"
          },
          right: {
            promoHeading: "Geschenkgutschein",
            promo: { img: "ebook-desktop-menue-feature-205.jpg", btn: "Gutschein kaufen", tall:true }
          }
        }
      }
    },

    /* ---------------------------------------------------------- SALE */
    { label: "Sale", href: "/collections/sale", sale: true }
  ];

  /* ===== App-Menü (Penoblo Menü-Manager) =====
     Liest den im Metaobject `pnb_menu` (Eintrag "published") veröffentlichten
     Baum (categories -> columns -> items -> children) und übersetzt ihn in das
     interne MENU-Format. Fallback-Kette: App-Menü -> Customizer-JSON -> DEFAULT. */
  function pnbItemHref(it){
    if (it && it.collectionHandle) {
      var href = "/collections/" + it.collectionHandle;
      if (it.filter && it.filter.key && it.filter.value) {
        href += "?filter.p." + it.filter.key + "=" + encodeURIComponent(it.filter.value);
      }
      return href;
    }
    return (it && it.url) || "#";
  }

  function treeToMenu(tree){
    if (!tree || !Array.isArray(tree.categories) || !tree.categories.length) return null;
    return tree.categories.map(function(cat){
      var cols = Array.isArray(cat.columns) ? cat.columns : [];
      // Kategorie-Link: explizite URL, sonst erster auflösbarer Eintrag (nie "#",
      // sonst entstehen tote Top-Links und kaputte Preis-Basen in Drilldowns).
      var catHref = cat.url;
      if (!catHref) {
        outer: for (var ci = 0; ci < cols.length; ci++) {
          var its = cols[ci].items || [];
          for (var ii = 0; ii < its.length; ii++) {
            var h = pnbItemHref(its[ii]);
            if (h && h !== "#") { catHref = h.split("?")[0]; break outer; }
          }
        }
      }
      var top = { label: cat.label || "", href: catHref || "#", sale: /sale/i.test(cat.label || "") };
      if (!cols.length) return top; // Direktlink ohne Panel

      var levels = {};
      /* Drill-Level 1:1 wie das Alt-Menü: Bild-Kinder = Kacheln (types), Text-
         Kinder = Link-Liste (brands), Preis-Kinder = Preis-Spalte, "Alle …" =
         Abschlusslink. Heading/Logo kommen aus dem Datenmodell. */
      /* 14.09.2026 — Parität mit dem Customizer-JSON (1:1-Umstellung auf das
         Studio-Menue): Das Drill-Objekt traegt dieselben Felder in derselben
         Form wie der Liquid-Aufbau in sections/pnb-mega-menu.liquid —
         logo/brandsHeading immer als String, brands immer als Array, cols2
         explizit (drilldownTwoColumns) statt nur berechnet, Abschlusslink
         auch ohne eigene URL (drilldownAllLabel -> Theme berechnet die
         Basis), Bild-Kacheln ohne Ziel bleiben erhalten (der Renderer leitet
         die URL aus Marke+Typ ab, genau wie bei Customizer-Kacheln), Kacheln
         mit Kindern oeffnen ein verschachteltes Drill-Level. */
      function buildDrill(it){
        var types = [], brands = [], priceItems = [], all = null, allHref = null;
        (it.children || []).forEach(function(ch){
          var href = pnbItemHref(ch);
          var label = ch.label || "";
          if (Array.isArray(ch.children) && ch.children.length) {
            types.push({ label: label, img: ch.imageUrl || "", to: ch.id });
            levels[ch.id] = buildDrill(ch);
            return;
          }
          if (ch.imageUrl) {
            var t = { label: label, img: ch.imageUrl };
            if (href !== "#") t.href = href;
            types.push(t);
            return;
          }
          if (href === "#") return; // unfertige Text-Einträge (kein Ziel) nicht live rendern
          if (/€/.test(label) && /filter\.v\.price/.test(href)) { priceItems.push({ label: label, href: href }); return; }
          if (/^Alle /.test(label) && !all) { all = label; allHref = href; return; }
          brands.push({ label: label, href: href });
        });
        var d = { __drill: true, name: it.label || "", logo: it.drilldownLogo || "", types: types };
        d.brandsHeading = it.drilldownHeading || "";
        d.cols2 = (typeof it.drilldownTwoColumns === "boolean") ? it.drilldownTwoColumns : brands.length > 8;
        d.brands = brands;
        if (priceItems.length) d.priceItems = priceItems;
        if (all) { d.all = all; d.allHref = allHref; }
        else if (it.drilldownAllLabel) d.all = it.drilldownAllLabel;
        return d;
      }
      function itemToCard(it){
        var card = { label: it.label || "", img: it.imageUrl || "" };
        if (Array.isArray(it.children) && it.children.length) {
          card.to = it.id;
          levels[it.id] = buildDrill(it);
        } else {
          card.href = pnbItemHref(it);
          if (card.href === "#") return null; // kein Ziel -> nicht live rendern
        }
        return card;
      }
      function itemToLink(it){
        if (Array.isArray(it.children) && it.children.length) {
          levels[it.id] = buildDrill(it);
          return { label: it.label || "", to: it.id };
        }
        var href = pnbItemHref(it);
        if (href === "#") return null; // kein Ziel -> nicht live rendern
        return { label: it.label || "", href: href };
      }
      function noNull(arr){ return arr.filter(function(x){ return x; }); }

      // Spalten klassifizieren: Promo -> rechte Werbespalte; überwiegend Bilder
      // -> Karten-Spalte; sonst Link-Spalte
      var cardCols = [], linkCols = [], promoCol = null;
      cols.forEach(function(col){
        if (col.promo && (col.promo.imageUrl || col.promo.buttonLabel)) { if (!promoCol) promoCol = col; return; }
        var items = col.items || [];
        var withImg = items.filter(function(i){ return i.imageUrl; }).length;
        if (items.length && withImg >= Math.ceil(items.length / 2)) cardCols.push(col);
        else linkCols.push(col);
      });

      var leftCol  = cardCols.shift() || null;
      var rest     = cardCols.concat(linkCols); // übrige Spalten als Link-Spalten
      var midCol   = rest.shift() || null;
      var rightCol = promoCol ? null : (rest.shift() || null);

      var left = leftCol
        ? { heading: leftCol.heading || "", wideCards: !!leftCol.logoCards, cards: noNull((leftCol.items || []).map(itemToCard)) }
        : { heading: "", cards: [] };
      var mid = midCol
        ? { heading: midCol.heading || "", links: noNull((midCol.items || []).map(itemToLink)) }
        : { heading: "", links: [] };
      // mehr als 3 Spalten: Rest an die Mitte anhängen (nichts verlieren)
      rest.forEach(function(col){ mid.links = mid.links.concat(noNull((col.items || []).map(itemToLink))); });
      /* Darstellungsfelder der Spalte (14.09.2026, Customizer-Paritaet):
         twoColumns -> cols2, allLabel -> Abschlusslink, priceList -> Standard-
         Preisstaffel. Ohne diese Felder blieb "Alle Marken" / die zweispaltige
         Liste / "Nach Preis shoppen" beim Studio-Menue auf der Strecke. */
      function spaltenFelder(col, ziel){
        if (!col) return ziel;
        if (typeof col.twoColumns === "boolean") ziel.cols2 = col.twoColumns;
        if (Array.isArray(col.priceList) && col.priceList.length) ziel.pricelist = col.priceList.slice();
        else if (col.priceList === true) ziel.pricelist = PRICE.slice();
        if (col.allLabel) ziel.all = col.allLabel;
        return ziel;
      }
      spaltenFelder(midCol, mid);
      var right;
      if (promoCol) {
        right = { promoHeading: promoCol.heading || "", promo: {
          img: promoCol.promo.imageUrl || "",
          btn: promoCol.promo.buttonLabel || null,
          href: promoCol.promo.href || null,
          tall: !!promoCol.promo.tall
        } };
      } else if (rightCol) {
        right = { heading: rightCol.heading || "" };
        var rightLinks = noNull((rightCol.items || []).map(itemToLink));
        if (rightLinks.length) right.links = rightLinks;
        spaltenFelder(rightCol, right);
      } else {
        right = { heading: "" };
      }

      top.levels = Object.assign({ root: { left: left, mid: mid, right: right } }, levels);
      return top;
    });
  }

  function normalizeConfiguredMenu(menu){
    if (!Array.isArray(menu)) return null;
    return menu.filter(item => item && typeof item === "object" && item.label);
  }

  function getConfiguredMenu(fallback){
    var treeEl = document.getElementById("pnbMenuTreeData");
    if (treeEl) {
      try {
        var appMenu = treeToMenu(JSON.parse(treeEl.textContent || "null"));
        if (appMenu && appMenu.length) return appMenu;
      } catch (error) {
        console.warn("PNB Mega-Menue: App-Menue ungueltig. Fallback wird verwendet.", error);
      }
    }
    const dataEl = document.getElementById("pnbMegaMenuData");
    if (!dataEl) return fallback;

    try {
      const configured = normalizeConfiguredMenu(JSON.parse(dataEl.textContent || "[]"));
      return configured && configured.length ? configured : fallback;
    } catch (error) {
      console.warn("PNB Mega-Menue: Customizer-JSON ist ungueltig. Standard-Menue wird verwendet.", error);
      return fallback;
    }
  }

  const MENU = getConfiguredMenu(DEFAULT_MENU);

  /* ================================================================
     Menü-Übersetzung (veröffentlichte Sprachen EN/FR)
     ----------------------------------------------------------------
     Die Labels kommen als JSON aus dem Penoblo Studio und lassen sich
     von Shopify nicht übersetzen. Das Wörterbuch (snippets/
     pnb-menu-i18n.liquid) wird deshalb hier angewendet — bewusst erst
     am gerenderten DOM: Aus den deutschen Labels leitet das Menü an
     mehreren Stellen Sammlungs-URLs ab (urlBrand/urlCat/levelBase),
     die dadurch unverändert und funktionsfähig bleiben.
     Ohne Wörterbuch (Deutsch) ist alles hier ein No-Op.
     ================================================================ */
  var MENU_I18N = (function () {
    /* Sprache aus <html lang> — von layout/theme.liquid aus request.locale
       gesetzt, also auf jeder lokalisierten URL (/en, /fr) korrekt. */
    var lang = (document.documentElement.getAttribute("lang") || "")
      .slice(0, 2)
      .toLowerCase();
    var map = (typeof PNB_MENU_I18N === "object" && PNB_MENU_I18N[lang]) || null;
    /* Optionale Übersteuerung aus Liquid (falls je gebraucht) */
    try {
      var el = document.getElementById("pnbMenuI18n");
      if (el) {
        var custom = JSON.parse(el.textContent || "null");
        if (custom && Object.keys(custom).length) map = custom;
      }
    } catch (e) {}
    return map && Object.keys(map).length ? map : null;
  })();

  var I18N_ATTRS = ["alt", "title"];

  function pnbTranslateDom(root) {
    if (!MENU_I18N || !root || !root.nodeType) return;
    /* Textknoten: nur exakte Treffer ersetzen, Umgebungs-Leerraum erhalten */
    if (root.nodeType === 3) {
      var raw0 = root.nodeValue || "", key0 = raw0.trim();
      if (key0 && MENU_I18N[key0]) root.nodeValue = raw0.replace(key0, MENU_I18N[key0]);
      return;
    }
    if (root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node, pending = [];
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue || "", key = raw.trim();
      if (key && MENU_I18N[key]) pending.push([node, raw.replace(key, MENU_I18N[key])]);
    }
    for (var i = 0; i < pending.length; i++) pending[i][0].nodeValue = pending[i][1];

    /* alt/title mitnehmen; data-* bleibt deutsch (dient als Suchschlüssel) */
    var els = root.querySelectorAll("[alt],[title]");
    for (var j = 0; j < els.length; j++) {
      for (var a = 0; a < I18N_ATTRS.length; a++) {
        var v = els[j].getAttribute(I18N_ATTRS[a]);
        if (v && MENU_I18N[v.trim()]) els[j].setAttribute(I18N_ATTRS[a], MENU_I18N[v.trim()]);
      }
    }
    if (root.matches && root.matches("[alt],[title]")) {
      for (var b = 0; b < I18N_ATTRS.length; b++) {
        var rv = root.getAttribute(I18N_ATTRS[b]);
        if (rv && MENU_I18N[rv.trim()]) root.setAttribute(I18N_ATTRS[b], MENU_I18N[rv.trim()]);
      }
    }
  }

  /* Jede Render-Route abdecken (Panel, Drill-down, Marken-Tab, Drawer),
     ohne jeden einzelnen innerHTML-Aufruf anzufassen. Wir beobachten nur
     hinzugefügte Knoten (childList) — unsere eigenen Textänderungen sind
     characterData und lösen deshalb keine Schleife aus. */
  function pnbObserveTranslations() {
    if (!MENU_I18N || typeof MutationObserver === "undefined") return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) pnbTranslateDom(added[j]);
      }
    });
    /* Neben dem Menü auch die Kategorie-Chips der Kollektionsseiten
       (pnb-collection-nav): deren Labels kommen aus dem JSON-Metafeld
       collection_builder.filter, das Shopify nicht übersetzen kann —
       dasselbe Wörterbuch greift deshalb auch dort. [data-pnb-i18n]
       können weitere Sections setzen, ohne dass dieses Skript wächst. */
    var roots = [document.querySelector(".pnb-mega-host"),
                 document.getElementById("menu-drawer"),
                 document.querySelector(".menu-drawer")];
    var extra = document.querySelectorAll(".pnb-collection-nav, [data-pnb-i18n]");
    for (var x = 0; x < extra.length; x++) roots.push(extra[x]);
    var seen = [];
    for (var k = 0; k < roots.length; k++) {
      var r = roots[k];
      if (!r || seen.indexOf(r) !== -1) continue;
      seen.push(r);
      pnbTranslateDom(r);
      observer.observe(r, { childList: true, subtree: true });
    }
  }

  /* Helper: erzeugt ein Drill-down-Level (Marke/Typ) mit Logo + Zurück.
     opts: { types:[{label,img}], brandsHeading, brands?[], pricelist?[], cols2?, all } */
  function brandDrill(name, logo, opts){
    return { __drill: true, name, logo, ...opts };
  }

  /* ================================================================
     RENDERING
     ================================================================ */
  const navEl   = document.getElementById("penNav");
  const megaEl  = document.getElementById("penMega");
  const innerEl = document.getElementById("penMegaInner");
  const dimEl   = document.getElementById("penDim");

  const cardHTML = (c, wide, context, fallbackAlt) => {
    const tag = c.to ? "button" : "a";
    let resolved = c.href;
    if (!c.to && (!resolved || resolved === "#")) {
      if (context && isKnownBrand(context.name) && isProductType(c.label)) {
        resolved = urlBrandType(context.name, c.label);
      } else {
        resolved = /^Alle /.test(c.label) ? urlCat(c.label.replace(/^Alle /,'')) : (c.label ? urlBrand(c.label) : "#");
      }
    }
    const attrs = c.to
      ? `type="button" data-to="${c.to}"`
      : `href="${loc(resolved || '#')}"`;
    const label = c.label ? `<span class="pen-card__label">${c.label}</span>` : "";
    const logoClass = wide ? " pen-card--brand-logo" : "";
    const imageSrc = img(c.img);
    // A11y: Kacheln ohne Label sind Links ohne sonstigen Text — das Bild-alt
    // uebernimmt dann den Kacheltitel (Fallback-Kette label -> title -> Menuename).
    const altText = c.label || c.title || fallbackAlt || (context && context.name) || "";
    return `<${tag} class="pen-card${logoClass}" ${attrs}>
        <img class="pen-card__img" loading="eager" decoding="async" fetchpriority="low" data-pnb-menu-img data-src="${imageSrc}" alt="${altText}" onerror="this.hidden=true;var card=this.closest('.pen-card');if(card)card.classList.add('pen-card--image-missing')" />
        ${label}
      </${tag}>`;
  };

  const linksHTML = (arr, two, kind, context) =>
    `<ul class="pen-links ${two ? 'pen-links--2' : ''}">` +
    arr.map(t => {
      const label = typeof t === "object" ? (t.label || t.title || "") : t;
      if (typeof t === "object" && t.to) {
        return `<li><button type="button" class="pen-links__drill" data-to="${t.to}">${label}<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg></button></li>`;
      }
      const explicitHref = typeof t === "object" ? (t.href || t.url) : null;
      const href = explicitHref || (kind === "brand" && context && isProductType(context.name)
        ? urlTypeBrand(context.name, label)
        : (kind === "brand" ? urlBrand(label) : urlCat(label)));
      return `<li><a href="${loc(href)}">${label}</a></li>`;
    }).join("") + `</ul>`;

  const priceHTML = (arr, base) =>
    `<ul class="pen-links pen-pricelist">` +
    arr.map(t => `<li><a href="${loc(urlPrice(t, base))}">${t}</a></li>`).join("") + `</ul>`;

  const allHTML = (label, base) =>
    `<hr class="pen-rule" /><ul class="pen-links pen-links--all"><li><a href="${loc(base||urlCat(label.replace(/^Alle /,'')))}">${label}</a></li></ul>`;

  /* baut die linke Spalte */
  function leftColHTML(left, menuName){
    const cards = `<div class="pen-cards">${left.cards.map(c => cardHTML(c, left.wideCards, null, menuName)).join("")}</div>`;
    return `<div class="pen-col pen-col--left">
        <div class="pen-heading">${left.heading || ""}</div>
        ${cards}
      </div>`;
  }

  /* baut eine Marken-/Highlights-/Preis-Spalte */
  function midColHTML(mid, base){
    let body = "";
    if (mid.links) body += linksHTML(mid.links, mid.cols2, 'cat');
    if (mid.pricelist) body += priceHTML(mid.pricelist, base);
    if (mid.all) body += allHTML(mid.all, base);
    return `<div class="pen-col">
        <div class="pen-heading">${mid.heading || ""}</div>
        ${body}
      </div>`;
  }

  /* baut die rechte Spalte (Promo oder Preis) */
  function rightColHTML(right, base){
    if (right.promo){
      const p = right.promo;
      /* UAT: ohne gepflegtes Ziel keinen toten #-Link rendern — Button als
         nicht-klickbares Element, Bild unverlinkt */
      const btn = p.btn
        ? (p.href
            ? `<a class="pen-promo__btn" href="${loc(p.href)}">${p.btn}</a>`
            : `<span class="pen-promo__btn" aria-disabled="true">${p.btn}</span>`)
        : "";
      const media = `<div class="pen-promo__media"><img loading="lazy" src="${img(p.img)}" alt="${p.caption || ''}" onerror="var m=this.closest('.pen-promo__media');if(m)m.hidden=true" /></div>`;
      const mediaLinked = p.href ? `<a class="pen-promo__medialink" href="${loc(p.href)}">${media}</a>` : media;
      return `<div class="pen-col pen-col--last">
          ${right.promoHeading ? `<div class="pen-heading">${right.promoHeading}</div>` : `<div class="pen-heading">&nbsp;</div>`}
          <div class="pen-promo ${p.tall ? 'pen-promo--tall' : ''}">
            ${mediaLinked}
            ${btn}
          </div>
        </div>`;
    }
    let body = "";
    if (right.links) body += linksHTML(right.links, right.cols2, 'cat');
    if (right.pricelist) body += priceHTML(right.pricelist, base);
    if (right.all) body += allHTML(right.all, base);
    return `<div class="pen-col pen-col--last">
        <div class="pen-heading">${right.heading || ""}</div>
        ${body}
      </div>`;
  }

  /* Root-Level (Startansicht eines Menüs) */
  function rootLevelHTML(root, base, menuName){
    return `${leftColHTML(root.left, menuName)}${midColHTML(root.mid, base)}${rightColHTML(root.right, base)}`;
  }


  /* Drill-down-Level (Marke / Typ): linke Spalte mit Logo + Zurück + Typ-Kacheln */
  function drillLevelHTML(d, base){
    const levelBase = isKnownBrand(d.name) ? urlBrand(d.name) : (isProductType(d.name) ? urlCat(d.name) : base);
    const back = `<button type="button" class="pen-back" data-back>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"></path></svg>
        ${BACK_LABEL}
      </button>`;
    const logo = d.logo ? `<img class="pen-brandlogo" src="${img(d.logo)}" alt="${d.name}" onerror="this.hidden=true" />` : "";
    const cards = `<div class="pen-cards">${d.types.map(t => cardHTML(t, false, d)).join("")}</div>`;
    const left = `<div class="pen-col pen-col--left">
        ${logo}${back}
        <div class="pen-heading">${d.name}</div>
        ${cards}
      </div>`;

    const allLink = d.all
      ? (d.allHref
          ? `<hr class="pen-rule" /><ul class="pen-links pen-links--all"><li><a href="${loc(d.allHref)}">${d.all}</a></li></ul>`
          : allHTML(d.all, levelBase))
      : "";
    let midBody = "";
    if (d.brands) midBody += linksHTML(d.brands, d.cols2, 'brand', d);
    if (d.pricelist) midBody += priceHTML(d.pricelist, levelBase);
    const mid = `<div class="pen-col">
        <div class="pen-heading">${d.brandsHeading || ""}</div>
        ${midBody}${allLink}
      </div>`;

    /* Preis-Spalte: explizite Preis-Links aus dem App-Menü haben Vorrang;
       sonst Standard-Staffel – aber nur mit echter Collection-Basis (sonst
       entstehen tote "#?filter.v.price…"-Links). */
    const priceBase = (levelBase && levelBase !== "#") ? levelBase : null;
    let right;
    if (d.priceItems && d.priceItems.length) {
      const items = `<ul class="pen-links pen-pricelist">` +
        d.priceItems.map(t => `<li><a href="${loc(t.href)}">${t.label}</a></li>`).join("") + `</ul>`;
      right = `<div class="pen-col pen-col--last">
        <div class="pen-heading">${PRICE_HEADING}</div>
        ${items}${allLink}
      </div>`;
    } else if (priceBase) {
      right = `<div class="pen-col pen-col--last">
        <div class="pen-heading">${PRICE_HEADING}</div>
        ${priceHTML(PRICE, priceBase)}${d.all ? allHTML(d.all, priceBase) : ""}
      </div>`;
    } else {
      right = `<div class="pen-col pen-col--last"></div>`;
    }

    return left + mid + right;
  }

  /* baut alle Panels (eines pro Top-Item) */
  function buildMega(){
    let html = "";
    MENU.forEach((m, mi) => {
      if (!m.levels) return;
      let levels = "";
      Object.keys(m.levels).forEach(key => {
        const lv = m.levels[key];
        const inner = lv.__drill ? drillLevelHTML(lv, m.href) : rootLevelHTML(lv, m.href, m.label);
        levels += `<div class="pen-level ${key==='root'?'is-active':''}" data-level="${key}">${inner}</div>`;
      });
      const slug = (m.label || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
      html += `<div class="pen-panel${slug ? ' pen-panel--' + slug : ''}" data-panel="${mi}">${levels}</div>`;
    });
    innerEl.innerHTML = html;
  }

  /* baut die Navigation */
  function buildNav(){
    navEl.innerHTML = MENU.map((m, i) => {
      const cls = m.sale ? "pen-nav__link pen-nav__link--sale" : "pen-nav__link";
      const hasMenu = !!m.levels;
      return `<li class="pen-nav__item" data-index="${i}" ${hasMenu?'data-haspanel="1"':''}>
          <a class="${cls}" href="${loc(m.href)}">${m.label}</a>
        </li>`;
    }).join("");
  }

  try {
    buildNav();
    buildMega();
  } catch (error) {
    // Unvollstaendige Menuedaten aus dem Customizer duerfen das Menue nicht
    // lahmlegen -> auf das eingebaute Standard-Menue zurueckfallen.
    console.warn("PNB Mega-Menue: Menuedaten unvollstaendig. Standard-Menue wird verwendet.", error);
    try {
      MENU.length = 0;
      Array.prototype.push.apply(MENU, DEFAULT_MENU);
      buildNav();
      buildMega();
    } catch (e2) {
      // Auch der Fallback darf die Uebersetzung darunter nicht verhindern.
      console.warn("PNB Mega-Menue: Standard-Menue nicht renderbar.", e2);
    }
  }

  /* Menü-Labels in der aktiven Sprache anzeigen (No-Op auf Deutsch).
     Muss nach dem ersten Rendern laufen und beobachtet danach alle
     nachgeladenen Panels/Drill-downs — und die Kategorie-Chips der
     Kollektionsseiten, deshalb darf sie NIE am Menue-Aufbau scheitern. */
  try { pnbObserveTranslations(); } catch (e) {}

  /* ================================================================
     INTERAKTION
     ================================================================ */
  const items = [...navEl.querySelectorAll(".pen-nav__item")];
  const panels = [...innerEl.querySelectorAll(".pen-panel")];
  let openIndex = -1;
  let closeTimer = null;
  let openTimer = null;
  var HOVER_OPEN_DELAY = 280; // ms – Hover-Intent: kein versehentliches Aufklappen beim Drueberfahren

  /* Netzwerk-Preload OHNE Markierung/Autoscale: setzt nur src (Browser laedt auch
     bei display:none), damit die Kacheln beim echten Oeffnen aus dem Cache kommen.
     hydratePanelImages() bleibt fuer Sichtbar-Logik (loaded-Flag, Logo-Autoscale,
     Fehlerbehandlung) zustaendig und laeuft danach unveraendert. */
  function preloadPanelImages(scope){
    if (!scope || scope.dataset.pnbPreloaded === "true") return;
    scope.dataset.pnbPreloaded = "true";
    scope.querySelectorAll('img[data-pnb-menu-img]').forEach(imgEl => {
      if (imgEl.dataset.loaded === "true" || imgEl.src) return;
      const src = imgEl.dataset.src;
      if (src) imgEl.src = src;
    });
    // Promo-/Logo-Bilder mit fixem src: lazy blockiert im versteckten Panel — auf eager drehen
    scope.querySelectorAll('img[loading="lazy"]').forEach(imgEl => { imgEl.loading = "eager"; });
  }

  function hydratePanelImages(scope){
    if (!scope) return;
    scope.querySelectorAll('img[data-pnb-menu-img]').forEach(imgEl => {
      if (imgEl.dataset.loaded === "true") return;
      const src = imgEl.dataset.src;
      if (!src) {
        imgEl.hidden = true;
        const card = imgEl.closest('.pen-card');
        if (card) card.classList.add('pen-card--image-missing');
        imgEl.dataset.loaded = "true";
        return;
      }
      imgEl.src = src;
      imgEl.dataset.loaded = "true";
      if (imgEl.closest('.pen-card--brand-logo')) pnbAutoscaleLogo(imgEl);
    });
  }

  /* ===== Einheitliche Logo-Größe =====
     Die Bilddateien haben unterschiedlich viel Weißraum (Porsche Design randlos,
     GvFC winzig). Regel: der SICHTBARE Logo-Inhalt wird per Pixel-Analyse
     vermessen und auf eine einheitliche Zielgröße skaliert — nie über die
     Kachel hinaus (harter Beschnitt-Schutz). Das Customizer-Setting
     --pen-brand-logo-scale wirkt als globaler Feintuning-Faktor obendrauf. */
  function pnbAutoscaleLogo(imgEl){
    var TARGET_W = 0.86, TARGET_H = 0.64;   // Ziel: Inhalt füllt ~86% Breite / 64% Höhe
    var SAFE_W = 0.94,  SAFE_H = 0.88;      // hartes Maximum (Beschnitt-Schutz)
    var WHITE = 246, ALPHA = 40;
    function apply(){
      try {
        var iw = imgEl.naturalWidth, ih = imgEl.naturalHeight;
        if (!iw || !ih) return;
        var cw = 160, ch = Math.max(1, Math.round(ih * cw / iw));
        var cv = document.createElement("canvas"); cv.width = cw; cv.height = ch;
        var cx = cv.getContext("2d", { willReadFrequently: true });
        cx.drawImage(imgEl, 0, 0, cw, ch);
        var d = cx.getImageData(0, 0, cw, ch).data;
        var minX = cw, minY = ch, maxX = -1, maxY = -1;
        for (var y = 0; y < ch; y++) {
          for (var x = 0; x < cw; x++) {
            var i = (y * cw + x) * 4;
            if (d[i + 3] > ALPHA && (d[i] < WHITE || d[i + 1] < WHITE || d[i + 2] < WHITE)) {
              if (x < minX) minX = x; if (x > maxX) maxX = x;
              if (y < minY) minY = y; if (y > maxY) maxY = y;
            }
          }
        }
        if (maxX < 0) return; // komplett weiß
        var fracW = (maxX - minX + 1) / cw, fracH = (maxY - minY + 1) / ch;
        var box = imgEl.getBoundingClientRect();
        if (!box.width) { requestAnimationFrame(apply); return; } // noch unsichtbar
        var st = getComputedStyle(imgEl);
        var innerW = box.width  - parseFloat(st.paddingLeft) - parseFloat(st.paddingRight);
        var innerH = box.height - parseFloat(st.paddingTop)  - parseFloat(st.paddingBottom);
        var fit = Math.min(innerW / iw, innerH / ih);       // object-fit: contain
        var contentW = iw * fit * fracW, contentH = ih * fit * fracH;
        var user = parseFloat(st.getPropertyValue("--pen-brand-logo-scale")) || 1;
        var s = Math.min(TARGET_W * box.width / contentW, TARGET_H * box.height / contentH) * user;
        var sMax = Math.min(SAFE_W * box.width / contentW, SAFE_H * box.height / contentH);
        s = Math.max(0.8, Math.min(s, sMax));
        imgEl.style.transform = "scale(" + s.toFixed(3) + ")";
      } catch (e) { /* z. B. Canvas tainted -> CSS-Fallback bleibt aktiv */ }
    }
    if (imgEl.complete && imgEl.naturalWidth) apply();
    else imgEl.addEventListener("load", apply, { once: true });
  }


  function showPanel(index){
    const item = items[index];
    if (!item || !item.dataset.haspanel) { closeMega(); return; }
    clearTimeout(closeTimer);
    // Panels umschalten
    panels.forEach(p => p.classList.toggle("is-active", +p.dataset.panel === index));
    // beim Öffnen immer Root-Level zeigen
    const panel = panels.find(p => +p.dataset.panel === index);
    if (panel) {
      resetToRoot(panel);
      hydratePanelImages(panel.querySelector('.pen-level.is-active') || panel);
    }
    items.forEach(it => it.classList.toggle("is-open", it === item));
    items.forEach(it => {
      const link = it.querySelector("a");
      if (link) link.setAttribute("aria-expanded", it === item ? "true" : "false");
    });
    /* Panel exakt auf den sichtbaren Platz begrenzen: die CSS-Pauschale
       (100dvh - 150px) stimmt nur, wenn die Nav ganz oben klebt. So endet
       das Panel immer im Viewport und das Mausrad scrollt die Liste. */
    try {
      var megaTop = megaEl.getBoundingClientRect().top;
      megaEl.style.maxHeight = Math.max(240, window.innerHeight - megaTop - 8) + "px";
    } catch (e) {}
    megaEl.classList.add("is-open");
    megaEl.setAttribute("aria-hidden","false");
    dimEl.classList.add("is-on");
    openIndex = index;
  }

  function resetToRoot(panel){
    panel.querySelectorAll(".pen-level").forEach(l =>
      l.classList.toggle("is-active", l.dataset.level === "root"));
  }

  function showLevel(panel, key){
    panel.querySelectorAll(".pen-level").forEach(l =>
      l.classList.toggle("is-active", l.dataset.level === key));
    hydratePanelImages(panel.querySelector(`.pen-level[data-level="${key}"]`));
  }

  function closeMega(){
    clearTimeout(openTimer);
    megaEl.classList.remove("is-open");
    megaEl.setAttribute("aria-hidden","true");
    dimEl.classList.remove("is-on");
    items.forEach(it => it.classList.remove("is-open"));
    items.forEach(it => {
      const link = it.querySelector("a");
      if (link) link.setAttribute("aria-expanded", "false");
    });
    openIndex = -1;
  }

  function scheduleClose(){
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMega, 160);
  }

  // Hover auf Nav-Items
  items.forEach(item => {
    const i = +item.dataset.index;
    const link = item.querySelector("a");
    if (item.dataset.haspanel && link) {
      link.setAttribute("aria-haspopup", "true");
      link.setAttribute("aria-expanded", "false");
    }
    item.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      // Bilder schon waehrend des Hover-Intents anstossen — so sind die Kacheln
      // beim Aufklappen (nach 280ms) meist bereits da statt 1-2s weiss.
      if (item.dataset.haspanel) {
        const p = panels.find(pp => +pp.dataset.panel === i);
        if (p) preloadPanelImages(p);
      }
      // Ist schon ein Menue offen, sofort wechseln; sonst erst nach kurzer Verzoegerung oeffnen.
      if (openIndex !== -1) { showPanel(i); }
      else { openTimer = setTimeout(() => showPanel(i), HOVER_OPEN_DELAY); }
    });
    item.addEventListener("mouseleave", () => {
      clearTimeout(openTimer);   // geplantes Oeffnen abbrechen, wenn die Maus nur drueberhuscht
      scheduleClose();
    });
    // Tastatur: Enter/Leertaste am fokussierten Trigger oeffnet das Panel.
    // Fokus allein oeffnet bewusst NICHT — sonst wechselt jeder weitere
    // Trigger-Fokus das Panel und die Panel-Links waeren per Tab nie
    // erreichbar (Panels liegen im DOM hinter allen Triggern).
    if (link) {
      link.addEventListener("keydown", (event) => {
        if (!item.dataset.haspanel) return;
        if (event.key === " " || event.key === "Spacebar") {
          event.preventDefault();
          if (openIndex === i) closeMega();
          else showPanel(i);
        }
      });
      link.addEventListener("click", (event) => {
        if (!item.dataset.haspanel) return;
        // Erster Klick/Tap/Enter oeffnet das Panel, ein weiterer navigiert —
        // so bleiben Top-Level-Links auch auf Touch-Geraeten erreichbar.
        if (openIndex !== i) {
          event.preventDefault();
          showPanel(i);
        }
      });
    }
  });

  // Maus bleibt im Mega-Menü -> offen halten
  megaEl.addEventListener("mouseenter", () => clearTimeout(closeTimer));
  megaEl.addEventListener("mouseleave", scheduleClose);

  // Tastatur: Verlaesst der Fokus Nav + Panel (z. B. Tab hinter dem letzten
  // Panel-Link), schliesst das Menue. Fokuswechsel innerhalb (Trigger <-> Panel)
  // laesst es offen; Maus-Interaktion bleibt unberuehrt (focusout feuert dort
  // nur bei echten Fokuswechseln).
  function onMegaFocusOut(e){
    const next = e.relatedTarget;
    if (!next) return; // Fokus ins Leere (z. B. Klick auf Dim) -> dim/close regelt das
    if (navEl.contains(next) || megaEl.contains(next)) return;
    if (openIndex !== -1) closeMega();
  }
  navEl.addEventListener("focusout", onMegaFocusOut);
  megaEl.addEventListener("focusout", onMegaFocusOut);

  /* ================================================================
     Mobiler Drawer: Marken-Menü v2 (Design-Handoff "Mobiles Menü Marken v2").
     Der Admin-Nav-Drawer zeigt unter "Marken" nur eine Teilmenge —
     hier wird dieselbe Quelle wie im Desktop-Mega-Menü (MENU) genutzt:
     Suchfeld mit Reset + Trefferzähler, "Zuletzt angesehen"-Chips,
     "Top Marken"-Logoreihe (dieselben Karten wie im Live-Mega-Menü),
     A-Z-Liste mit Gruppenzählern + ANGEBOT-Badges, Schnellsprung-Rail,
     Tap-Toast und Scroll-Restore. */
  const escHtml = (s) => String(s).replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const normBrand = (s) => String(s).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
  /* Toleranter Such-Schlüssel: "dupont" findet "S.T. Dupont", "rossler" "Rössler" */
  const searchKey = (s) => normBrand(s).replace(/[^A-Z0-9]/g, "");
  const RECENT_KEY = "pnb-mm-v2-recent";
  const SCROLL_KEY = "pnb-mm-v2-scroll";
  const REDUCED_MOTION = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function collectBrandList(){
    const cat = MENU.find(m => m && m.levels && /^marken\b/i.test(m.label || ""));
    if (!cat || !cat.levels || !cat.levels.root) return [];
    const out = new Map();
    const push = (label, href) => {
      const l = (label || "").trim();
      if (!l) return;
      const h = href || urlBrand(l);
      if (!h || h === "#") return;
      if (!out.has(l)) out.set(l, h);
    };
    ["left", "mid", "right"].forEach(k => {
      const col = cat.levels.root[k];
      if (!col) return;
      (col.links || []).forEach(c => {
        if (typeof c === "string") push(c, urlBrand(c));
        else if (c && !c.to) push(c.label, c.href || urlBrand(c.label));
      });
      (col.cards || []).forEach(c => {
        if (c && c.label && (c.href || isKnownBrand(c.label))) push(c.label, c.href || urlBrand(c.label));
      });
    });
    return [...out.entries()].map(([label, href]) => ({ label, href }))
      .sort((a, b) => a.label.localeCompare(b.label, "de", { sensitivity: "base" }));
  }

  /* "Top Marken" = exakt die Logo-Karten des Live-Mega-Menüs (MENU root.left.cards) */
  function collectTopBrands(){
    const cat = MENU.find(m => m && m.levels && /^marken\b/i.test(m.label || ""));
    const cards = cat && cat.levels && cat.levels.root && cat.levels.root.left && cat.levels.root.left.cards;
    if (!cards) return { cards: [], allHref: "" };
    /* Auch Marken OHNE Bild mitnehmen (im Studio ohne Bild angelegt, Befund
       17.09.2026): sie bekommen unten eine Textkachel statt zu fehlen. */
    return {
      cards: cards.filter(c => c && c.label).map(c => ({
        label: c.label, img: c.img ? img(c.img) : "", href: c.href || urlBrand(c.label)
      })).filter(c => c.href && c.href !== "#"),
      allHref: (cat && cat.href) || ""
    };
  }

  function readRecent(){
    try {
      const r = JSON.parse(localStorage.getItem(RECENT_KEY) || "null");
      return Array.isArray(r) ? r.filter(x => typeof x === "string").slice(0, 6) : [];
    } catch (e) { return []; }
  }
  function pushRecent(label){
    try {
      const r = [label, ...readRecent().filter(n => n !== label)].slice(0, 6);
      localStorage.setItem(RECENT_KEY, JSON.stringify(r));
    } catch (e) {}
  }

  function enhanceDrawerBrands(){
    try {
      const summaries = document.querySelectorAll(".menu-drawer summary.menu-drawer__menu-item");
      const pnbBrandsLabel = ((NAV_DATA && NAV_DATA.getAttribute("data-brands-label")) || "Marken").trim().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const pnbBrandsRe = new RegExp("^(" + pnbBrandsLabel + "|marken|brands|marques)\\b", "i");
      const summary = [...summaries].find(s => pnbBrandsRe.test((s.textContent || "").trim()));
      if (!summary) return;
      const details = summary.closest("details");
      const inner = details && details.querySelector(".menu-drawer__inner-submenu");
      if (!inner || inner.querySelector(".pnb-brandsearch")) return;
      const navEl = document.getElementById("penNav");
      const attr = (name, fb) => (navEl && navEl.getAttribute(name)) || fb;
      const FIND_LABEL = attr("data-find-brand", "Marke finden…");
      const EMPTY_LABEL = attr("data-no-brand", "Keine Marke gefunden. Prüfe die Schreibweise oder stöbere in den Top Marken.");
      const RECENT_LABEL = attr("data-recent-label", "Zuletzt angesehen");
      const TOP_LABEL = attr("data-top-label", "Top Marken");
      const TOP_LINK_LABEL = attr("data-top-link-label", "Zur Markenseite");
      const RESULTS_LABEL = attr("data-results-label", "{count} Treffer");
      const RESULTS_ONE_LABEL = attr("data-results-label-one", RESULTS_LABEL);
      const SALE_LABEL = attr("data-sale-label", "Angebot");
      const LOADING_LABEL = attr("data-loading-label", "{brand} wird geladen …");
      const RESET_LABEL = attr("data-reset-label", "Suche zurücksetzen");
      const saleSet = new Set(attr("data-sale-brands", "").split(",").map(s => searchKey(s)).filter(Boolean));
      const brands = collectBrandList();
      if (brands.length < 5) return; // dünne Datenlage -> Admin-Nav unangetastet lassen
      const top = collectTopBrands();
      const brandHref = new Map(brands.map(b => [b.label, b.href]));
      top.cards.forEach(c => { if (!brandHref.has(c.label)) brandHref.set(c.label, c.href); });

      /* ---- A-Z-Liste mit Buchstaben-Bändern (Zähler wird live gepflegt) ---- */
      let currentLetter = "", items = "";
      brands.forEach(b => {
        const first = normBrand(b.label).charAt(0);
        const letter = /[A-Z]/.test(first) ? first : "#";
        if (letter !== currentLetter) {
          currentLetter = letter;
          items += `<li class="pnb-brandsearch__letter" data-letter="${letter}"><span data-letter-label>${letter}</span></li>`;
        }
        const sale = saleSet.has(searchKey(b.label));
        items += `<li class="pnb-brandsearch__item" data-brand="${escHtml(searchKey(b.label))}">` +
          `<a class="menu-drawer__menu-item link link--text list-menu__item focus-inset" href="${escHtml(loc(b.href))}" data-brand-label="${escHtml(b.label)}">` +
          `<span class="pnb-brandsearch__name">${escHtml(b.label)}</span>` +
          (sale ? `<span class="pnb-brandsearch__badge">${escHtml(SALE_LABEL)}</span>` : "") +
          `<span class="pnb-brandsearch__arrow" aria-hidden="true">&#8594;</span></a></li>`;
      });

      /* ---- Top-Marken-Kacheln (Logos wie im Live-Theme, lazy) ---- */
      let topRow = "";
      if (top.cards.length) {
        const tiles = top.cards.map((c, ti) =>
          `<a class="pnb-brandsearch__topcard" href="${escHtml(loc(c.href))}" data-brand-label="${escHtml(c.label)}">` +
            (c.img
              ? `<span class="pnb-brandsearch__toplogo"><img ${ti < 5 ? `src="${escHtml(c.img)}"` : `data-src="${escHtml(c.img)}"`} alt="${escHtml(c.label)}" width="150" height="84" loading="lazy" decoding="async" fetchpriority="low" onerror="this.hidden=true"></span>`
              : `<span class="pnb-brandsearch__toplogo pnb-brandsearch__toplogo--text" aria-hidden="true">${escHtml(c.label)}</span>`) +
            `<span class="pnb-brandsearch__topname">${escHtml(c.label)}</span></a>`).join("");
        topRow =
          `<div class="pnb-brandsearch__top" data-hide-on-search>` +
            `<div class="pnb-brandsearch__tophead">` +
              `<div class="pnb-brandsearch__toptitle">${escHtml(TOP_LABEL)}</div>` +
              (top.allHref ? `<a class="pnb-brandsearch__toplink" href="${escHtml(loc(top.allHref))}">${escHtml(TOP_LINK_LABEL)}</a>` : "") +
            `</div>` +
            `<div class="pnb-brandsearch__toprow">${tiles}</div>` +
          `</div>`;
      }

      const wrap = document.createElement("div");
      wrap.className = "pnb-brandsearch";
      wrap.innerHTML =
        `<div class="pnb-brandsearch__field">` +
          `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>` +
          `<input type="search" placeholder="${escHtml(FIND_LABEL)}" aria-label="${escHtml(FIND_LABEL)}" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">` +
          `<button type="button" class="pnb-brandsearch__reset" aria-label="${escHtml(RESET_LABEL)}" hidden>` +
            `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"></path></svg>` +
          `</button>` +
        `</div>` +
        `<p class="pnb-brandsearch__count" role="status" aria-live="polite"></p>` +
        `<div class="pnb-brandsearch__recent" data-hide-on-search hidden>` +
          `<div class="pnb-brandsearch__eyebrow">${escHtml(RECENT_LABEL)}</div>` +
          `<div class="pnb-brandsearch__chips"></div>` +
        `</div>` +
        topRow +
        `<ul class="menu-drawer__menu list-menu pnb-brandsearch__list" role="list">${items}</ul>` +
        `<p class="pnb-brandsearch__empty" hidden>${escHtml(EMPTY_LABEL)}</p>`;

      const origUl = inner.querySelector("ul.menu-drawer__menu");
      if (origUl) {
        origUl.classList.add("pnb-brandsearch__orig-hidden");
        origUl.parentNode.insertBefore(wrap, origUl);
      } else {
        inner.appendChild(wrap);
      }

      const input = wrap.querySelector("input");
      const reset = wrap.querySelector(".pnb-brandsearch__reset");
      const count = wrap.querySelector(".pnb-brandsearch__count");
      const rows = [...wrap.querySelectorAll(".pnb-brandsearch__item")];
      const letters = [...wrap.querySelectorAll(".pnb-brandsearch__letter")];
      const empty = wrap.querySelector(".pnb-brandsearch__empty");
      const hideOnSearch = [...wrap.querySelectorAll("[data-hide-on-search]")];
      /* Rail als fixes Overlay am Drawer-Root: schwebt rechts über der Liste
         und bleibt beim Scrollen immer sichtbar (sticky scheiterte an
         Transform-/Overflow-Kontexten der Drawer-Untermenüs). */
      const railHost = wrap.closest("#menu-drawer") || wrap.closest(".menu-drawer") || wrap;
      const oldRail = railHost.querySelector(":scope > .pnb-brandsearch__railwrap");
      if (oldRail) oldRail.remove();
      const railwrap = document.createElement("div");
      railwrap.className = "pnb-brandsearch__railwrap";
      railwrap.hidden = true;
      railwrap.innerHTML = `<div class="pnb-brandsearch__rail"></div>`;
      railHost.appendChild(railwrap);
      const rail = railwrap.querySelector(".pnb-brandsearch__rail");
      const recentBox = wrap.querySelector(".pnb-brandsearch__recent");
      const chipsBox = wrap.querySelector(".pnb-brandsearch__chips");

      /* Top-Logos ab Kachel 6 erst beim Heranscrollen laden (21 Desktop-Assets
         sonst gleichzeitig auf Mobilfunk); Fallback: alle sofort hydratisieren */
      const toprowEl = wrap.querySelector(".pnb-brandsearch__toprow");
      if (toprowEl) {
        const deferred = [...toprowEl.querySelectorAll("img[data-src]")];
        const hydrate = (imgEl) => { if (imgEl.dataset.src) { imgEl.src = imgEl.dataset.src; delete imgEl.dataset.src; } };
        if ("IntersectionObserver" in window && deferred.length) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach(en => { if (en.isIntersecting) { hydrate(en.target); io.unobserve(en.target); } });
          }, { root: toprowEl, rootMargin: "0px 300px 0px 300px" });
          deferred.forEach(imgEl => io.observe(imgEl));
        } else {
          deferred.forEach(hydrate);
        }
      }

      /* Scroll-Container des Drawers finden (dort scrollt der Menü-Inhalt) */
      function getScroller(){
        let el = wrap.parentElement;
        while (el && el !== document.body) {
          const o = getComputedStyle(el).overflowY;
          if ((o === "auto" || o === "scroll") && el.scrollHeight > el.clientHeight) return el;
          el = el.parentElement;
        }
        return wrap.closest(".menu-drawer__navigation-container") || null;
      }

      /* ---- "Zuletzt angesehen"-Chips ---- */
      function renderRecent(){
        const r = readRecent().filter(l => brandHref.has(l));
        recentBox.hidden = r.length === 0 || input.value.trim() !== "";
        chipsBox.innerHTML = r.map(l =>
          `<a class="pnb-brandsearch__chip" href="${escHtml(loc(brandHref.get(l)))}" data-brand-label="${escHtml(l)}">${escHtml(l)}</a>`).join("");
      }
      renderRecent();

      /* ---- A-Z-Rail (nur vorhandene Buchstaben) ---- */
      function renderRail(){
        const visible = letters.filter(l => !l.hidden);
        railwrap.hidden = visible.length < 4 || !details.open;
        rail.innerHTML = visible.map(l =>
          `<button type="button" data-jump="${l.dataset.letter}">${l.dataset.letter}</button>`).join("");
      }
      /* Marken-Tab öffnen/schließen (auch Tab-Wechsel) blendet die Rail um */
      details.addEventListener("toggle", renderRail);
      function jumpToLetter(letter, instant){
        const band = letters.find(l => l.dataset.letter === letter && !l.hidden);
        const sc = getScroller();
        if (!band || !sc) return;
        const topPos = band.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - 4;
        sc.scrollTo({ top: topPos, behavior: (instant || REDUCED_MOTION) ? "auto" : "smooth" });
      }
      rail.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-jump]");
        if (btn) jumpToLetter(btn.dataset.jump);
      });
      /* Finger ueber die Rail ziehen springt durch die Buchstaben (kompensiert
         die kompakten 20px-Targets — WCAG-Muster nativer Index-Leisten) */
      let lastDragLetter = "";
      rail.addEventListener("touchmove", (e) => {
        const t = e.touches && e.touches[0];
        if (!t) return;
        /* Rail selbst vertikal scrollbar (niedrige Viewports): natives Scrollen
           nicht per preventDefault blockieren — Buchstaben-Auswahl dann nur per Tap. */
        if (rail.scrollHeight > rail.clientHeight) return;
        e.preventDefault();
        const el = document.elementFromPoint(t.clientX, t.clientY);
        const btn = el && el.closest && el.closest("[data-jump]");
        if (btn && btn.dataset.jump !== lastDragLetter) {
          lastDragLetter = btn.dataset.jump;
          jumpToLetter(lastDragLetter, true);
        }
      }, { passive: false });
      rail.addEventListener("touchend", () => { lastDragLetter = ""; });

      /* ---- Live-Suche: tolerant, mit Reset, Treffer- und Gruppenzählern ---- */
      function applyFilter(){
        const q = searchKey(input.value.trim());
        let any = 0;
        rows.forEach(r => {
          const hit = !q || r.dataset.brand.indexOf(q) !== -1;
          r.hidden = !hit;
          if (hit) any++;
        });
        letters.forEach(l => {
          let el = l.nextElementSibling, n = 0;
          while (el && !el.classList.contains("pnb-brandsearch__letter")) {
            if (!el.hidden) n++;
            el = el.nextElementSibling;
          }
          l.hidden = n === 0;
          const lbl = l.querySelector("[data-letter-label]");
          if (lbl) lbl.textContent = q ? l.dataset.letter + " · " + n : l.dataset.letter;
        });
        empty.hidden = any > 0;
        reset.hidden = !q;
        count.textContent = q ? (any === 1 ? RESULTS_ONE_LABEL : RESULTS_LABEL).replace("{count}", any) : "";
        hideOnSearch.forEach(el => { el.hidden = !!q || (el === recentBox && !readRecent().length); });
        if (!q) renderRecent();
        renderRail();
      }
      input.addEventListener("input", applyFilter);
      reset.addEventListener("click", () => {
        input.value = "";
        applyFilter();
        input.focus();
      });
      renderRail();

      /* ---- Tap-Feedback + "Zuletzt angesehen" pflegen (Liste, Kacheln, Chips) ---- */
      let toastEl = null, toastTimer = 0;
      function showToast(label){
        if (!toastEl) {
          toastEl = document.createElement("div");
          toastEl.className = "pnb-brandsearch__toast";
          toastEl.setAttribute("aria-hidden", "true");
          (document.getElementById("menu-drawer") || document.body).appendChild(toastEl);
        }
        toastEl.textContent = LOADING_LABEL.replace("{brand}", label);
        toastEl.classList.add("is-on");
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => toastEl.classList.remove("is-on"), 1400);
      }
      wrap.addEventListener("click", (e) => {
        const a = e.target.closest("[data-brand-label]");
        if (!a) return;
        pushRecent(a.getAttribute("data-brand-label"));
        showToast(a.getAttribute("data-brand-label"));
      });

      /* ---- Scroll-Restore: Position im Marken-Tab pro Session merken.
              Capture-Listener am Drawer-Root: Scroll-Events bubblen nicht,
              erreichen den Root aber in der Capture-Phase — so wird der
              tatsächlich scrollende Container erfasst, egal welcher es
              je Breakpoint ist (zur Injektionszeit ist der Drawer zu und
              alle Höhen 0, eine frühe Messung wäre unzuverlässig). ---- */
      const drawerRoot = wrap.closest("#menu-drawer") || wrap.closest(".menu-drawer");
      if (drawerRoot) {
        let raf = 0, lastScrolled = null;
        drawerRoot.addEventListener("scroll", (e) => {
          if (e.target && typeof e.target.scrollTop === "number") lastScrolled = e.target;
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = 0;
            if (details.hasAttribute("open") && lastScrolled) {
              try { sessionStorage.setItem(SCROLL_KEY, String(lastScrolled.scrollTop)); } catch (e2) {}
            }
          });
        }, { capture: true, passive: true });
      }
      details.addEventListener("toggle", () => {
        if (!details.open) return;
        renderRecent();
        const sc = getScroller();
        let saved = 0;
        try { saved = parseInt(sessionStorage.getItem(SCROLL_KEY) || "0", 10) || 0; } catch (e) {}
        if (sc && saved > 0) requestAnimationFrame(() => { sc.scrollTop = saved; });
      });
    } catch (e) { /* Drawer bleibt im Fehlerfall unveraendert nutzbar */ }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", enhanceDrawerBrands, { once: true });
  else enhanceDrawerBrands();

  // Nach dem Seitenaufbau alle Panel-Bilder im Leerlauf vorladen (kleine
  // Kachel-Assets) — erster Menue-Kontakt zeigt dann sofort fertige Bilder.
  function idlePreloadAll(){
    var run = function(){ panels.forEach(p => preloadPanelImages(p)); };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 4000 });
    else setTimeout(run, 1500);
  }
  if (document.readyState === 'complete') idlePreloadAll();
  else window.addEventListener('load', idlePreloadAll, { once: true });

  // Drill-down / Zurück per Klick (Event-Delegation)
  innerEl.addEventListener("click", (e) => {
    const toBtn = e.target.closest("[data-to]");
    const backBtn = e.target.closest("[data-back]");
    const panel = e.target.closest(".pen-panel");
    if (!panel) return;
    if (toBtn){ e.preventDefault(); showLevel(panel, toBtn.dataset.to); }
    if (backBtn){ e.preventDefault(); resetToRoot(panel); }
  });

  // Escape schließt. Das Script liegt in der Section und re-runt bei jedem
  // Re-Render -> vorhandenen document-Listener vorher abmelden, damit nicht
  // bei jedem Render ein weiterer (auf veraltete closeMega) akkumuliert.
  if (window.__pnbMegaKeydown) document.removeEventListener("keydown", window.__pnbMegaKeydown);
  window.__pnbMegaKeydown = function (e) {
    if (e.key !== "Escape") return;
    // A11y: Fokus zurueck auf den Trigger des geschlossenen Panels
    const trigger = openIndex !== -1 && items[openIndex] ? items[openIndex].querySelector("a") : null;
    closeMega();
    if (trigger) trigger.focus();
  };
  document.addEventListener("keydown", window.__pnbMegaKeydown);
  dimEl.addEventListener("click", closeMega);

}

  pnbInitMegaMenu();

  /* Theme-Editor-Robustheit: Beim Section-Re-Render ersetzt Shopify das
     Section-DOM, das per JS gerenderte Menue waere sonst weg -> Initialisierung
     erneut ausfuehren. Globales Flag verhindert doppelte Listener, falls das
     Script selbst noch einmal ausgefuehrt wird; die Init-Funktion selbst ist
     mehrfach aufrufbar (s. o.). */
  if (!window.__pnbMegaSectionLoadBound) {
    window.__pnbMegaSectionLoadBound = true;
    document.addEventListener("shopify:section:load", function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector("#penNav")) pnbInitMegaMenu();
    });
  }
})();
